var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParkingCarReducedbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "parkingCarReduced_before_svg__Ebene_1",
    "data-name": "Ebene 1",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 1258 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .parkingCarReduced_before_svg__cls-11,.parkingCarReduced_before_svg__cls-13,.parkingCarReduced_before_svg__cls-15,.parkingCarReduced_before_svg__cls-2,.parkingCarReduced_before_svg__cls-7,.parkingCarReduced_before_svg__cls-9{stroke:#343a50}.parkingCarReduced_before_svg__cls-11,.parkingCarReduced_before_svg__cls-13,.parkingCarReduced_before_svg__cls-15,.parkingCarReduced_before_svg__cls-2,.parkingCarReduced_before_svg__cls-9{stroke-miterlimit:10}.parkingCarReduced_before_svg__cls-2{fill:#eec6a2}.parkingCarReduced_before_svg__cls-11,.parkingCarReduced_before_svg__cls-13,.parkingCarReduced_before_svg__cls-15,.parkingCarReduced_before_svg__cls-2,.parkingCarReduced_before_svg__cls-7,.parkingCarReduced_before_svg__cls-9{stroke-width:2px}.parkingCarReduced_before_svg__cls-3{fill:#eb9a6b}.parkingCarReduced_before_svg__cls-4{fill:#343a50}.parkingCarReduced_before_svg__cls-5{fill:#d38259}.parkingCarReduced_before_svg__cls-7{fill:#dedede;stroke-linecap:round;stroke-linejoin:round}.parkingCarReduced_before_svg__cls-9{fill:#7fc3ca}.parkingCarReduced_before_svg__cls-11{fill:#d3ac8c}.parkingCarReduced_before_svg__cls-13,.parkingCarReduced_before_svg__cls-16{fill:#fff}.parkingCarReduced_before_svg__cls-15{fill:#065494}.parkingCarReduced_before_svg__cls-16{font-size:68.76px;font-family:Lato-Regular,Lato}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__Weniger_Parkpl\\xE4tze_Vorher",
    "data-name": "Weniger Parkpl\\xE4tze_Vorher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__Parkplatz"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "parkingCarReduced_before_svg__Boden",
    fill: "#4f4f4e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.99,
    points: "1259 481.39 -.96 481.39 -1 744.96 1259.04 744.87 1259 481.39"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "parkingCarReduced_before_svg__Weg",
    points: "759.82 744.87 491.68 744.87 521.86 481.24 729.43 481.24 759.82 744.87",
    className: "parkingCarReduced_before_svg__cls-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__Haus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__Wand"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 440.33,
    x: -1,
    y: -1,
    className: "parkingCarReduced_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 0v438.33H0V0h1258m2-2H-2v442.33h1262V-2z",
    className: "parkingCarReduced_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__Linke_Wand"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 358.8,
    height: 440.33,
    x: -1,
    y: -1,
    className: "parkingCarReduced_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.8 0v438.33H0V0h356.8m2-2H-2v442.33h360.8V-2z",
    className: "parkingCarReduced_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 331.22,
    height: 383.33,
    x: 464.31,
    y: 56,
    fill: "#bc7353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.52 57v381.33H465.31V57h329.21m2-2H463.31v385.33h333.21V55z",
    className: "parkingCarReduced_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 265.48,
    height: 360.17,
    x: 494.95,
    y: 79.16,
    className: "parkingCarReduced_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.43 80.16v358.17H496V80.16h263.43m2-2H494v362.17h267.43V78.16z",
    className: "parkingCarReduced_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 465.31,
    x2: 494.63,
    y1: 57,
    y2: 79.16,
    className: "parkingCarReduced_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 794.52,
    x2: 760.79,
    y1: 57,
    y2: 78.41,
    className: "parkingCarReduced_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__T\\xFCr"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "parkingCarReduced_before_svg__T\\xFCr-2",
    width: 165.18,
    height: 336.88,
    x: 547.33,
    y: 102.72,
    fill: "#a98969",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-name": "T\\xFCr"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "parkingCarReduced_before_svg__Fenster4",
    width: 99.73,
    height: 63.23,
    x: 580.05,
    y: 136.54,
    className: "parkingCarReduced_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "parkingCarReduced_before_svg__Fenster3",
    width: 99.73,
    height: 63.23,
    x: 580.05,
    y: 207.25,
    className: "parkingCarReduced_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "parkingCarReduced_before_svg__Fenster2",
    width: 99.73,
    height: 63.23,
    x: 580.05,
    y: 276.88,
    className: "parkingCarReduced_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "parkingCarReduced_before_svg__Fenster1",
    width: 99.73,
    height: 63.23,
    x: 580.05,
    y: 346.58,
    className: "parkingCarReduced_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "parkingCarReduced_before_svg__T\\xFCrknauf",
    cx: 679.78,
    cy: 273.81,
    r: 9.57,
    fill: "#fcbe42",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__Fenster_links"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.51,
    height: 328.88,
    x: 30.94,
    y: 35.38,
    className: "parkingCarReduced_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.91 364.25 117.91 213.15 30.93 213.15 30.93 186.45 117.91 186.45 117.91 35.34 144.5 35.34 144.5 186.45 231.45 186.45 231.45 213.15 144.5 213.15 144.5 364.25 117.91 364.25",
    className: "parkingCarReduced_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 36.35v151.1h86.95v24.7H143.5v151.1h-24.59v-151.1h-87v-24.7h87V36.35h24.59m2-2h-28.59v151.1h-87v28.7h87v151.1h28.59v-151.1h86.95v-28.7H145.5V34.35z",
    className: "parkingCarReduced_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__Fesnter_rechts2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.51,
    height: 328.88,
    x: 1042.97,
    y: 54.78,
    className: "parkingCarReduced_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1129.94 383.66 1129.94 232.57 1042.96 232.57 1042.96 205.87 1129.94 205.87 1129.94 54.77 1156.53 54.77 1156.53 205.87 1243.47 205.87 1243.47 232.57 1156.53 232.57 1156.53 383.66 1129.94 383.66",
    className: "parkingCarReduced_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.53 55.78v151.09h86.94v24.7h-86.94v151.09H1131V231.57h-87v-24.7h87V55.78h24.58m2-2h-28.59v151.1h-87v28.7h87v151.08h28.59V233.57h87v-28.7h-87V53.77z",
    className: "parkingCarReduced_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__Fesnter_rechts1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.51,
    height: 328.88,
    x: 824.98,
    y: 54.83,
    className: "parkingCarReduced_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "911.96 383.71 911.96 232.62 824.98 232.62 824.98 205.92 911.96 205.92 911.96 54.83 938.55 54.83 938.55 205.92 1025.49 205.92 1025.49 232.62 938.55 232.62 938.55 383.71 911.96 383.71",
    className: "parkingCarReduced_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.55 55.83v151.09h86.94v24.7h-86.94v151.09H913V231.62h-87v-24.7h87V55.83h24.59m2-2H911v151.09h-87v28.7h87v151.09h28.59V233.62h86.94v-28.7h-86.98V53.83z",
    className: "parkingCarReduced_before_svg__cls-4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__B\\xFCrgersteig_hinten"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-.96 481.65 1259 481.65 1260.5 438.52 -1 438.52 -.96 481.65",
    className: "parkingCarReduced_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.72 458.53 -1 458.53 -.96 481.39 1259.45 481.65 1260.72 458.53",
    className: "parkingCarReduced_before_svg__cls-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__Stra\\xDFe"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1261,
    height: 338.13,
    x: -1.5,
    y: 743.37,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 744.87V1080H0V744.87h1258m3-3H-3V1083h1264V741.87z",
    className: "parkingCarReduced_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__B\\xFCrgersteig_vorne"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260.02,
    height: 43.13,
    x: -0.94,
    y: 701.74,
    className: "parkingCarReduced_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.08 721.74 -.98 721.74 -.94 744.87 1259.08 744.87 1259.08 721.74",
    className: "parkingCarReduced_before_svg__cls-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__Stra\\xDFenmarkierung"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198.61,
    height: 23.62,
    x: -1.02,
    y: 900.63,
    className: "parkingCarReduced_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.88,
    height: 23.62,
    x: 398.3,
    y: 900.63,
    className: "parkingCarReduced_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.88,
    height: 23.62,
    x: 799.47,
    y: 900.63,
    className: "parkingCarReduced_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57.86,
    height: 23.62,
    x: 1201.23,
    y: 900.63,
    className: "parkingCarReduced_before_svg__cls-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_before_svg__Schilder"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.32,
    height: 168.32,
    x: 77.12,
    y: 331.22,
    fill: "#828282",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.47
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.55,
    height: 104.35,
    x: 44,
    y: 253.87,
    className: "parkingCarReduced_before_svg__cls-15",
    rx: 15.46
  }), /*#__PURE__*/React.createElement("text", {
    className: "parkingCarReduced_before_svg__cls-16",
    transform: "matrix(1.04 0 0 1 60.09 325.23)"
  }, "\r\n    P\r\n   "), /*#__PURE__*/React.createElement("rect", {
    width: 3.32,
    height: 158.5,
    x: 397.7,
    y: 341.02,
    fill: "#828282",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.37
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.55,
    height: 104.35,
    x: 364.58,
    y: 253.02,
    className: "parkingCarReduced_before_svg__cls-15",
    rx: 15.46
  }), /*#__PURE__*/React.createElement("text", {
    className: "parkingCarReduced_before_svg__cls-16",
    transform: "matrix(1.04 0 0 1 380.43 325.25)"
  }, "\r\n    P\r\n   "), /*#__PURE__*/React.createElement("rect", {
    width: 3.32,
    height: 167.28,
    x: 844.21,
    y: 332.27,
    fill: "#828282",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.55,
    height: 104.35,
    x: 811.1,
    y: 253.56,
    className: "parkingCarReduced_before_svg__cls-15",
    rx: 15.46
  }), /*#__PURE__*/React.createElement("text", {
    className: "parkingCarReduced_before_svg__cls-16",
    transform: "matrix(1.04 0 0 1 827.19 326.28)"
  }, "\r\n    P\r\n   "), /*#__PURE__*/React.createElement("rect", {
    width: 3.32,
    height: 157.48,
    x: 1164.79,
    y: 342.07,
    fill: "#828282",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.55,
    height: 104.35,
    x: 1131.68,
    y: 253.3,
    className: "parkingCarReduced_before_svg__cls-15",
    rx: 15.46
  }), /*#__PURE__*/React.createElement("text", {
    className: "parkingCarReduced_before_svg__cls-16",
    transform: "matrix(1.04 0 0 1 1147.53 326.3)"
  }, "\r\n    P\r\n   ")))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingCarReducedbefore);
export default __webpack_public_path__ + "static/media/parkingCarReduced.before.7e415017.svg";
export { ForwardRef as ReactComponent };